import Text from 'components/Text';
import cn from './styles.local.less';

interface Props {
  title: string;
  children: any;
}

export default function BlockWrapper(props: Props) {
  const { title, children } = props;

  return (
    <div className={cn.root}>
      <Text size="m" tag="h2" className={cn.title}>
        {title}
      </Text>
      {children}
    </div>
  );
}
